export default __webpack_public_path__ + "static/media/floor1.4ed51b38.png";